import type { VariantProps } from 'class-variance-authority'
import { cva } from 'class-variance-authority'

export type BlockquoteVariantProps = VariantProps<typeof blockquoteVariants.base>

export type BlockquoteIntent = NonNullable<BlockquoteVariantProps['intent']>

export type BlockquoteSize = NonNullable<BlockquoteVariantProps['size']>

export const blockquoteVariants = {
  base: cva([
    'flex',
    'text-primary',
    'gap-s',
    'rounded-4xl',
  ], {
    variants: {
      intent: {
        filled: ['bg-section-alternate'],
        neutral: ['bg-transparent'],
      },
      size: {
        small: ['py-l', 'sm:px-m'],
        large: ['py-xl', 'sm:pl-l', 'sm:pr-xl'],
      },
    },
  }),

  content: cva([], {
    variants: {
      intent: {
        filled: [],
        neutral: [],
      },
      size: {
        small: ['text-body', '[&>*]:text-body'],
        large: ['text-2xl [&>*]:text-2xl', 'font-semibold', 'font-heading [&>*]:font-heading', 'flex', 'flex-col', 'gap-xs'],
      },
    },
    compoundVariants: [
      {
        intent: 'neutral',
        size: 'small',
        class: [
          'italic',

          // Add quotes
          'before:content-["«"]',
          'after:content-["»"]',
        ],
      },
    ],
  }),

  author: cva(['flex', 'flex-col', 'text-small', 'font-normal', 'gap-3xs'], {
    variants: {
      intent: {
        filled: [],
        neutral: [],
      },
      size: {
        small: [],
        large: [],
      },
    },
    compoundVariants: [
      {
        intent: 'neutral',
        size: 'small',
        class: ['text-carbon-300'],
      },
    ],
  }),
}
